import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {px, percent, vh} from '@packages/systems/core/utils/WebflowCssSubset';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {USYS_DATA_ATTRS} from '@packages/systems/users/constants';
import {mockUser, placeholderUser} from './mockUser';
import {WF_COLLECTION_DATA_KEY} from '@packages/systems/commerce/constants';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {SHARED_DYN_WRAPPER_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {isUserComponentRoot} from '@packages/utilities/platform';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const {DESIGNER} = WebflowEnvironments;

const UserAccountWrapper = Atom.createRender(
  ({data, renderChild, generateAttributes, attributes, classes, context}) => {
    let newContext = context;

    const runtimeEnvironment = useRuntimeEnvironment();

    if (runtimeEnvironment === DESIGNER) {
      newContext = context.set('data', mockUser);
    } else {
      newContext = context.set('data', placeholderUser);
    }

    return (
      <div
        {...generateAttributes(attributes, classes)}
        {...{[USYS_DATA_ATTRS.userAccount]: true}}
        {...{[WF_COLLECTION_DATA_KEY]: 'site.siteUser'}}
      >
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, newContext)
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'User Account Wrapper',
  showEmpty: true,
  constraints: {
    descendants: [
      {is: 'UserAccountFormWrapper', rule: 'ExactlyOne'},
      {is: 'UserAccountSubscriptionListWrapper', rule: 'ZeroOrOne'},
      {
        is: {
          check: (element, componentMap) =>
            isUserComponentRoot(componentMap, element),
          name: 'Symbol',
        },
        rule: 'Forbid',
      },
      ...SHARED_DYN_WRAPPER_CONSTRAINTS_DESCENDANTS.filter(
        (constraint) => constraint.is !== 'UserAccountSubscriptionListWrapper'
      ),
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          width: percent(100),
          minHeight: vh(100),
          paddingTop: px(20),
          paddingBottom: px(20),
          paddingRight: px(20),
          paddingLeft: px(20),
          backgroundColor: createRgbaColor('f5f5f5'),
        },
      },
    },
  },
  render: UserAccountWrapper,
  fields: {children: TListOfElement},
});

export default config;
